declare namespace $ {

	type __shm_hitalama_map_book_1 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['widget_headers_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['widget_headers_visible'] >[0]
	>
	type __shm_hitalama_map_book_2 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['widget_list_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['widget_list_visible'] >[0]
	>
	type __shm_hitalama_map_book_3 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['file_list_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['file_list_visible'] >[0]
	>
	type __shm_hitalama_map_book_4 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['editor_mode_enabled'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['editor_mode_enabled'] >[0]
	>
	type __shm_hitalama_map_book_5 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['arrows_visible'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Head'] >['arrows_visible'] >[0]
	>
	type $shm_hitalama_map_head__map_shm_hitalama_map_book_6 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map'] >
		,
		ReturnType< $shm_hitalama_map_head['map'] >
	>
	type $shm_hitalama_map_head__zoom_shm_hitalama_map_book_7 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['zoom'] >
		,
		ReturnType< $shm_hitalama_map_head['zoom'] >
	>
	type $shm_hitalama_map_head__shift_shm_hitalama_map_book_8 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['shift'] >
		,
		ReturnType< $shm_hitalama_map_head['shift'] >
	>
	type $shm_hitalama_map_head__map_cut_shm_hitalama_map_book_9 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map_cut'] >
		,
		ReturnType< $shm_hitalama_map_head['map_cut'] >
	>
	type $shm_hitalama_map_book_widgets3__map_shm_hitalama_map_book_10 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['map'] >
	>
	type $shm_hitalama_map_book_widgets3__Map_page_shm_hitalama_map_book_11 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['Map_page'] >
	>
	type $shm_hitalama_map_book_widgets3__editor_mode_enabled_shm_hitalama_map_book_12 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['editor_mode_enabled'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['editor_mode_enabled'] >
	>
	type $shm_hitalama_map_book_widgets3__widget_list_visible_shm_hitalama_map_book_13 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_list_visible'] >
		,
		ReturnType< $shm_hitalama_map_book_widgets3['widget_list_visible'] >
	>
	type __shm_hitalama_map_book_14 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['zoom'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Map_page'] >['zoom'] >[0]
	>
	type __shm_hitalama_map_book_15 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['shift'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Map_page'] >['shift'] >[0]
	>
	type __shm_hitalama_map_book_16 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['go_to_widget'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Map_page'] >['go_to_widget'] >[0]
	>
	type __shm_hitalama_map_book_17 = $mol_type_enforce<
		Parameters< $shm_hitalama_map_book['Widget'] >[0]
		,
		Parameters< ReturnType< $shm_hitalama_map_book['Map_page'] >['Widget'] >[0]
	>
	type $shm_hitalama_map_page__entity_shm_hitalama_map_book_18 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['entity'] >
		,
		ReturnType< $shm_hitalama_map_page['entity'] >
	>
	type $shm_hitalama_map_page__cut_shm_hitalama_map_book_19 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map_cut'] >
		,
		ReturnType< $shm_hitalama_map_page['cut'] >
	>
	type $shm_hitalama_map_page__widget_headers_visible_shm_hitalama_map_book_20 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_headers_visible'] >
		,
		ReturnType< $shm_hitalama_map_page['widget_headers_visible'] >
	>
	type $shm_hitalama_map_page__arrows_visible_shm_hitalama_map_book_21 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['arrows_visible'] >
		,
		ReturnType< $shm_hitalama_map_page['arrows_visible'] >
	>
	type $shm_hitalama_map_page__tool_mode_shm_hitalama_map_book_22 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['tool_mode'] >
		,
		ReturnType< $shm_hitalama_map_page['tool_mode'] >
	>
	type $shm_hitalama_map_editor__map_shm_hitalama_map_book_23 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['map'] >
		,
		ReturnType< $shm_hitalama_map_editor['map'] >
	>
	type $shm_hitalama_map_editor__widget_shm_hitalama_map_book_24 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_for_editor'] >
		,
		ReturnType< $shm_hitalama_map_editor['widget'] >
	>
	type $shm_hitalama_map_editor__Widget_shm_hitalama_map_book_25 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Widget'] >
		,
		ReturnType< $shm_hitalama_map_editor['Widget'] >
	>
	type $mol_view__title_shm_hitalama_map_book_26 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['title'] >
		,
		ReturnType< $mol_view['title'] >
	>
	type $mol_view__sub_shm_hitalama_map_book_27 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['page_sub'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $shm_hitalama_map_widget_page__widget_shm_hitalama_map_book_28 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_for_settings'] >
		,
		ReturnType< $shm_hitalama_map_widget_page['widget'] >
	>
	type $shm_hitalama_map_widget_page__Map_page_shm_hitalama_map_book_29 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_page['Map_page'] >
	>
	type $shm_hitalama_map_book_tools__tool_mode_shm_hitalama_map_book_30 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['tool_mode'] >
		,
		ReturnType< $shm_hitalama_map_book_tools['tool_mode'] >
	>
	type $shm_hitalama_map_book_tools__style_shm_hitalama_map_book_31 = $mol_type_enforce<
		({ 
			'left': ReturnType< $shm_hitalama_map_book['tool_modes_left'] >,
		}) 
		,
		ReturnType< $shm_hitalama_map_book_tools['style'] >
	>
	type $shm_hitalama_map_widget_presets_page__Map_page_shm_hitalama_map_book_32 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Map_page'] >
		,
		ReturnType< $shm_hitalama_map_widget_presets_page['Map_page'] >
	>
	type $mol_check_icon__checked_shm_hitalama_map_book_33 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['widget_list_visible'] >
		,
		ReturnType< $mol_check_icon['checked'] >
	>
	type $mol_check_icon__Icon_shm_hitalama_map_book_34 = $mol_type_enforce<
		ReturnType< $shm_hitalama_map_book['Widgets_visible_icon'] >
		,
		ReturnType< $mol_check_icon['Icon'] >
	>
	export class $shm_hitalama_map_book extends $mol_book2 {
		title( ): string
		map_cut( ): any
		widget_headers_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['widget_headers_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['widget_headers_visible'] >
		widget_list_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['widget_list_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['widget_list_visible'] >
		file_list_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['file_list_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['file_list_visible'] >
		editor_mode_enabled( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['editor_mode_enabled'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['editor_mode_enabled'] >
		arrows_visible( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['arrows_visible'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Head'] >['arrows_visible'] >
		Head( ): $shm_hitalama_map_head
		Widgets( ): $shm_hitalama_map_book_widgets3
		widget_list_view( ): readonly(any)[]
		entity( ): $giper_baza_entity
		map( ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['map'] >
		zoom( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['zoom'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['zoom'] >
		shift( next?: ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['shift'] > ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['shift'] >
		widgets_filtered( ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['widgets_filtered'] >
		selected_links( ): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['selected_links'] >
		go_to_widget( id: any): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['go_to_widget'] >
		Widget( id: any): ReturnType< ReturnType< $shm_hitalama_map_book['Map_page'] >['Widget'] >
		Map_page( ): $shm_hitalama_map_page
		widget_for_editor( ): any
		Editor( ): $shm_hitalama_map_editor
		map_or_editor( ): readonly(any)[]
		page_sub( ): readonly(any)[]
		Page( ): $mol_view
		widget_for_settings( ): any
		Widget_props( ): $shm_hitalama_map_widget_page
		widget_props_visible( ): readonly(any)[]
		tool_mode( next?: string ): string
		tool_modes_left( ): string
		Widgets_visible_icon( ): $mol_icon_format_list_bulleted
		placeholders( ): readonly(any)[]
		menu_title( ): ReturnType< $shm_hitalama_map_book['title'] >
		pages( ): readonly(any)[]
		Tool_modes( ): $shm_hitalama_map_book_tools
		Presets_page( ): $shm_hitalama_map_widget_presets_page
		Widgets_visible( ): $mol_check_icon
	}
	
}

//# sourceMappingURL=book.view.tree.d.ts.map